import EmailRecipientsInput from 'components/input/EmailInput/EmailRecipientsInput';
import { Flex } from 'components/layout';

type DraftRecipientFieldsProps = {
  to: string[];
  cc: string[];
  bcc: string[];
  onToChange: (emails: string[]) => void;
  onCcChange: (emails: string[]) => void;
  onBccChange: (emails: string[]) => void;
};

// Reply-all defaults; Send/Draft apply the lists shown here with replyMode replyAll.
export function DraftRecipientFields({
  to,
  cc,
  bcc,
  onToChange,
  onCcChange,
  onBccChange,
}: DraftRecipientFieldsProps) {
  return (
    <Flex direction='col' gap='sm' className='w-full mt-3'>
      <EmailRecipientsInput
        name='to'
        label='To'
        value={to}
        onChange={onToChange}
        allowMultiple={true}
        placeholder='Type or paste email(s) here'
      />
      <EmailRecipientsInput
        name='cc'
        label='Cc:'
        value={cc}
        onChange={onCcChange}
        allowMultiple={true}
        placeholder='Type or paste email(s) here'
      />
      <EmailRecipientsInput
        name='bcc'
        label='Bcc:'
        value={bcc}
        onChange={onBccChange}
        allowMultiple={true}
        placeholder='Type or paste email(s) here'
      />
    </Flex>
  );
}
